import { render, staticRenderFns } from "./EntregaProdutosComprasItemContentSaldoRow.vue?vue&type=template&id=8c315944"
import script from "./EntregaProdutosComprasItemContentSaldoRow.vue?vue&type=script&lang=js"
export * from "./EntregaProdutosComprasItemContentSaldoRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports